import CommercialSummary from '../components/commercial/CommercialSummary'
import FrequencySummary from '../components/rfm/FrequencySummary'
import VisitSummarySection from '../components/summaryvisit/VisitSummarySection'
import SectionCollapse from '../../layout/SectionCollapse'
import Section from '../../layout/Section'
import GoogleIcon from '../../../components/icon/GoogleIcon'
import ClientActivityDetails from './ClientActivityDetails'
import DateRangeCard from './header/DateRangeCard'
import LoadingSpinner from '../../../components/LoadingSpinner'
import {
  CLIENT_DASHBOARD_COLORS,
  CLIENT_DASHBOARD_ICON_SIZES
} from '../constants/ClientDashboardConst'

export default function ClientDashboard({
  clientId,
  tableData,
  cardData,
  usersFilterData,
  currentPage,
  setPagination,
  totalPages,
  handlePaginationClick,
  searchQuery,
  onSearchQuery,
  filterQuery,
  setFilterQuery,
  isTableDataFetching,
  isCardDataFetching,
  isFilterDataFetching,
  DefaultDates,
  handleDateFilter,
  selectedDates,
  resetDates
}) {
  const isDashboardFetching = (isTableDataFetching && isCardDataFetching) || isFilterDataFetching

  return (
    <div>
      {/* <SectionCollapse   //////TBD: Data de Metas Comerciales.
        title="METAS COMERCIALES"
        type="title"
        icon={
          <GoogleIcon
            name="flag_circle"
            filled
            size={CLIENT_DASHBOARD_ICON_SIZES.large}
            color={CLIENT_DASHBOARD_COLORS.primaryIcon}
          />
        }
      >
        <GoalsSummarySection />
      </SectionCollapse> */}

      <Section
        title="KPIS"
        icon={
          <GoogleIcon
            name="summarize"
            filled
            size={CLIENT_DASHBOARD_ICON_SIZES.large}
            color={CLIENT_DASHBOARD_COLORS.primaryIcon}
          />
        }
      >
        <DateRangeCard
          value={selectedDates}
          onChange={handleDateFilter}
          defaultDates={DefaultDates}
          onResetAll={resetDates}
        />
        {isDashboardFetching ? (
          <div className="loading-fullscreen">
            <div className="loading-card">
              <LoadingSpinner text="Cargando..." />
            </div>
          </div>
        ) : (
          <>
            <SectionCollapse
              title="RESUMEN COMERCIAL"
              type="secondary"
              icon={
                <GoogleIcon
                  name="data_usage"
                  filled
                  size={CLIENT_DASHBOARD_ICON_SIZES.default}
                  color={CLIENT_DASHBOARD_COLORS.secondaryIcon}
                />
              }
            >
              <CommercialSummary cardInfo={cardData.card_info} />
            </SectionCollapse>

            <SectionCollapse
              title="RECENCIA, FRECUENCIA Y DINERO (RFM)"
              type="secondary"
              icon={
                <GoogleIcon
                  name="full_stacked_bar_chart"
                  filled
                  size={CLIENT_DASHBOARD_ICON_SIZES.default}
                  color={CLIENT_DASHBOARD_COLORS.secondaryIcon}
                />
              }
            >
              <FrequencySummary cardInfo={cardData.card_info} />
            </SectionCollapse>

            <SectionCollapse
              title="RESUMEN DE VISITA"
              type="secondary"
              icon={
                <GoogleIcon
                  name="article_person"
                  filled
                  size={CLIENT_DASHBOARD_ICON_SIZES.default}
                  color={CLIENT_DASHBOARD_COLORS.secondaryIcon}
                />
              }
            >
              <VisitSummarySection
                cardInfo={cardData.card_info}
                routeUsersInfo={cardData.route_users_info}
                clientId={clientId}
              />
            </SectionCollapse>
            <ClientActivityDetails
              tableData={tableData}
              usersFilterData={usersFilterData}
              currentPage={currentPage}
              setPagination={setPagination}
              totalPages={totalPages}
              handlePaginationClick={handlePaginationClick}
              searchQuery={searchQuery}
              onSearchQuery={onSearchQuery}
              filterQuery={filterQuery}
              setFilterQuery={setFilterQuery}
              isTableDataFetching={isTableDataFetching}
              isFilterDataFetching={isFilterDataFetching}
            />
          </>
        )}
      </Section>
    </div>
  )
}
